import {
  ADD_TO_CART,
  CART_CLEAR,
  DELETE_CART_ITEM,
} from "../Types";
import {
  forgotPasswordOtp,
  forgotPasswordApi,
  postSignIn,
  postSignUp,
  setNewPasswordApi,
  forgotPasswordEmailApi,
} from "../../network/Network";
import { toast } from "react-toastify";
import { setError } from "../actions/AlertAction";
import { responses, responsesLogin } from "../../constant/ConstantFunction";

export const AddToCart = (payload) => {
  return {
    type: ADD_TO_CART,
    payload,
  };
};

export const ClearCart = (payload) => {
  return {
    type: CART_CLEAR,
    payload,
  };
};

export const deleteCartItem = (currentItem) => (dispatch) => {
  dispatch({
    type: DELETE_CART_ITEM,
    payload: currentItem,
  });
};

